module.exports = __webpack_public_path__ + "img/arrow-right-double.bff2e549.svg";